import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import api, { apiError } from "../../lib/api";

export const SendReportButton = () => {
    const [busy, setBusy] = useState(false);
    const send = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/admin/analytics/weekly-email");
            toast.success(`Last week's report is on its way to ${data.sent_to}`);
        } catch (e) {
            toast.error(apiError(e.response?.data?.detail) || "Couldn't send the report");
        } finally {
            setBusy(false);
        }
    };
    return (
        <button
            data-testid="analytics-send-report-btn"
            onClick={send}
            disabled={busy}
            className="inline-flex items-center gap-2 rounded-full border border-sky-400/40 bg-sky-400/10 px-4 py-2 text-xs font-semibold text-sky-200 transition-[background-color,transform] duration-200 hover:bg-sky-400/20 active:scale-95 disabled:opacity-60"
        >
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />}
            {busy ? "Sending…" : "Send me last week's report"}
        </button>
    );
};
